module.exports = {
      id: "comments-outline-usage",
      viewBox: "0 0 32 36",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#comments-outline",
      toString: function () {
        return this.url;
      }
    }